import {Injectable, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';

@Injectable()
export class RouterExtService  implements OnInit {

  private previousUrl: string = "/pages/dashboard";
  private currentUrl: string = '';

  constructor(private router : Router) {

  }

  ngOnInit(): void {
    this.currentUrl = this.router.url;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        console.log(event)
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      }
    });
  }

  public getPreviousUrl(){
    return this.previousUrl;
  }
}
